// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var LayersEnum;
(function (LayersEnum) {
    LayersEnum[LayersEnum["None"] = 0] = "None";
    LayersEnum[LayersEnum["Main"] = 1] = "Main";
    LayersEnum[LayersEnum["Quotes"] = 2] = "Quotes";
    LayersEnum[LayersEnum["CrossHair"] = 4] = "CrossHair";
    LayersEnum[LayersEnum["Tools"] = 8] = "Tools";
    LayersEnum[LayersEnum["All"] = 15] = "All"; /* ~ (Main | Quotes | CrossHair | Tools) */
})(LayersEnum || (LayersEnum = {}));
